import { render, staticRenderFns } from "./CustomDetails.vue?vue&type=template&id=6728352f&scoped=true"
import script from "./CustomDetails.vue?vue&type=script&lang=js"
export * from "./CustomDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomDetails.vue?vue&type=style&index=0&id=6728352f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6728352f",
  null
  
)

export default component.exports